
import request from '@/utils/request'


export function fetchDrawStatus(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/draw/quota-log/status',
    method: 'get',
    params: data
  })
}


// WEBPACK FOOTER //
// ./src/views/activity_80/api.js